export const ContactType = {
  typePhone: 'Телефон',
  typeWhatsapp: 'WhatsApp',
  typeTelegram: 'Telegram',
};
